import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {    
    path: "/login",
    name: "login",    
    component: () => import("../components/LoginPanel.vue"),
  },
  {    
    path: "/token/:token",
    name: "token",
    props: true,
    component: () => import("../components/TokenPanel.vue"),
  },  
  {
    path:"/ContestList",
    name:"ContestList",
    component: () => import("@/components/ContestList.vue"),
  },
  {
    path:"/RoleList",
    name:"RoleList",
    component: () => import("@/components/rolemanage/RoleList.vue"),
  },
  {
    path:"/SyncT484",
    name:"SyncT484",
    component: () => import("@/components/rolemanage/syncT484.vue"),
  },
  {
    path:"/edit",
    name:"edit",
    component: () => import("@/components/pub/EditContest.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/ViewFile",
    name: "ViewFile",       
    component: () => import("@/views/ViewFile.vue"),
  },  
  {
    path: "/downLoadExcel",
    name: "downLoadExcel",       
    component: () => import("@/components/downLoadExcel.vue"),
  },
  {
    path: "/upLoadExcel",
    name: "upLoadExcel",       
    component: () => import("@/components/upLoadExcel.vue"),
  },  
  {
    path: "/upLoadExcelLogs",
    name: "upLoadExcelLogs",       
    component: () => import("@/components/upLoadExcelLogs.vue"),
  },  
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
